var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIconsGb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.1 11.4",
    style: {
      enableBackground: "new 0 0 17.1 11.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#405C40;}\r\n\t.st1{clip-path:url(#SVGID_00000168096612763753860890000009103554969465793703_);fill:#405C40;}\r\n\t.st2{clip-path:url(#SVGID_00000008126370372805283370000004135255146570260370_);fill:#405C40;}\r\n\t.st3{clip-path:url(#SVGID_00000062170463280606669480000004911432990899661442_);fill:#405C40;}\r\n\t.st4{clip-path:url(#SVGID_00000067930267368904393620000003634076128780307134_);fill:#405C40;}\r\n\t.st5{clip-path:url(#SVGID_00000141457509320119527990000005021215492325113768_);fill:#405C40;}\r\n\t.st6{fill:#CD2D40;}\r\n\t.st7{fill:#0D468F;}\r\n\t.st8{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    width: 7.6,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6.7,
    className: "st8",
    width: 7.6,
    height: 4.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "17.1,4.7 17.1,6.7 9.5,6.7 9.5,11.4 7.6,11.4 7.6,6.7 0,6.7 0,4.7 7.6,4.7 7.6,0 9.5,0 9.5,4.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "0,4 4,4 0,1.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "0,7.4 0,10.1 4,7.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2,11.4 6.8,11.4 6.8,8.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2,0 6.8,0 6.8,3.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "0,0.9 4.6,4 6,4 0,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "6,7.4 0,11.4 1.3,11.4 6.8,7.7 6.8,7.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    className: "st8",
    width: 7.5,
    height: 4.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 6.7,
    className: "st8",
    width: 7.5,
    height: 4.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "13.1,7.4 17.1,10.1 17.1,7.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "13.1,4 17.1,4 17.1,1.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "15.1,0 10.3,0 10.3,3.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "15.1,11.4 10.3,11.4 10.3,8.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "11.1,7.4 17.1,11.4 17.1,10.5 12.5,7.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "15.8,0 10.3,3.7 10.3,4 11.1,4 17.1,0  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconsGb);
export default __webpack_public_path__ + "static/media/InfoIcons_Gb.438b20ea09df82de657620d66e0725ba.svg";
export { ForwardRef as ReactComponent };